// ABOUTME: Hook excluding or re-including find & replace rows via PATCH /runs/:runId/exclusions.
// ABOUTME: Works by row seqs or by a rows filter; resolves with the updated count, callers refetch rows and run.

import { useCallback, useState } from 'react';

import { patchFindReplaceExclusions } from '../api/findReplaceApi';
import { ExclusionsFilter } from '../types';

export function useFindReplaceExclusions(runId: string | null) {
    const [pending, setPending] = useState(false);

    const send = useCallback(
        async (body: Parameters<typeof patchFindReplaceExclusions>[1]): Promise<number> => {
            if (!runId) return 0;
            setPending(true);
            try {
                const { updated } = await patchFindReplaceExclusions(runId, body);
                return updated;
            } finally {
                setPending(false);
            }
        },
        [runId],
    );

    const setExcludedBySeqs = useCallback(
        (seqs: number[], excluded: boolean) => send({ excluded, seqs }),
        [send],
    );

    const setExcludedByFilter = useCallback(
        (filter: ExclusionsFilter, excluded: boolean) => send({ excluded, filter }),
        [send],
    );

    return { setExcludedBySeqs, setExcludedByFilter, pending };
}
